import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import styled, { withTheme } from '../../../theming/styled-components.js';
import themes from '../../../theming/themes.js';
import React, { memo } from 'react';
import _Box from '../../../components/Box/index.js';

var _templateObject;
var StyledBox = styled(_Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-top-left-radius: 0;\n  margin-top: 0;\n  border: ", ";\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.tabs.containerBorder;
}, function (_ref2) {
  var tabs = _ref2.theme.tabs;
  return tabs.containerPadding && "\n    padding: ".concat(tabs.containerPadding, ";\n  ");
});
var TabPanel = function TabPanel(_ref3) {
  var children = _ref3.children,
    name = _ref3.name,
    isHidden = _ref3.isHidden,
    _ref3$theme = _ref3.theme,
    theme = _ref3$theme === void 0 ? themes["default"] : _ref3$theme;
  var ariaLabelName = name === null || name === void 0 ? void 0 : name.toLocaleLowerCase().replace(/\s+/g, '-');
  return /*#__PURE__*/React.createElement(StyledBox, {
    tabIndex: 0,
    role: "tabpanel",
    id: "".concat(ariaLabelName, "-tab-panel"),
    "aria-labelledby": "".concat(ariaLabelName, "-tab-button"),
    hidden: isHidden,
    theme: theme
  }, children);
};
var TabPanel$1 = withTheme(/*#__PURE__*/memo(TabPanel));

export default TabPanel$1;
